import * as React from 'react';
import Emoji from '../emoji';

if (process.env.BROWSER) {
  require('./index.less');
}

export interface ICommentMessageProp {
  message: string;
}

export default class CommentMessage extends React.PureComponent<ICommentMessageProp> {
  public render(): JSX.Element {
    // for russian
    return <div className={'comment-item-message'}>
      <Emoji urlPrefix={'http://img.ucweb.com/s/uae/g/1s/flow/emoji/v1_ru'} message={this.props.message}></Emoji>
    </div>;
  }
}
